import React from 'react';
import {
  Typography,
  Box,
  Paper,
  CircularProgress,
  Button,
  List,
  IconButton,
} from '@mui/material';
import { History as HistoryIcon, Refresh } from '@mui/icons-material';
import api from 'services/api';
import useAppStore from 'store/useAppStore';
import RenderHistoryItem from './RenderHistoryItem';
const HistoryArea = ({ fullScriptId, setEditedFullScript }) => {
  const user_id = useAppStore((state) => state.user.id);
  const comp_name = useAppStore((state) => state.user.company);
  const project_id = useAppStore((state) => state.selectedProject.project_id);
  const { currentData, isFetching, isError, refetch } =
    api.endpoints.getFullScriptList.useQuery({
      full_script_id: fullScriptId,
      flag: '0',
      user_id: user_id || '',
      comp_name: comp_name || '',
      project_id: project_id || '',
    });
  if (!currentData && isFetching) {
    return <CircularProgress />;
  }
  if (isError) {
    return (
      <div className="flex flex-col items-center p-2">
        取得資料發生錯誤
        <Button component="span" onClick={refetch}>
          重試
        </Button>
      </div>
    );
  }
  return (
    <Paper className="flex min-w-0 flex-1 flex-col p-2" variant="outlined">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <HistoryIcon color="primary" />
        <Typography variant="h6">歷史紀錄</Typography>
        <IconButton className="ml-auto" onClick={refetch} loading={isFetching}>
          <Refresh />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {currentData.full_script_list.length === 0 ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: 'center', mt: 4 }}
          >
            尚無歷史版本
          </Typography>
        ) : (
          <List>
            {currentData.full_script_list.map((item) => (
              <RenderHistoryItem
                key={`${item.script_name}${item.edit_time}`}
                data={item}
                fullScriptId={fullScriptId}
                setEditedFullScript={setEditedFullScript}
              />
            ))}
          </List>
        )}
      </Box>
    </Paper>
  );
};
export default HistoryArea;
